<template>
	<v-card flat>
		<v-card-title>
<!--			<h2>Scan a barcode</h2>
			<v-spacer></v-spacer>
-->
			<v-text-field @keyup.enter="checkBarcode" ref="barcode" v-model="barcode" append-icon="search" label="Scan a barcode" single-line hide-details solo class="elevation-2"></v-text-field>
			<v-spacer></v-spacer>
		</v-card-title>
		<v-data-table hide-actions :headers="barcodeSearchHeaders" :items="barcodeSearch" :rows-per-page-items="barcodeSearchRowsPerPage" class="elevation-1">
			<template v-slot:items="props">
				<tr class="lighten-5" :class="{ green: props.item.borrowed, red:! props.item.borrowed }">
					<td :class="{ title: !props.index }">{{ props.item.collection }}</td>
					<td :class="{ title: !props.index }">{{ props.item.title }}</td>
					<td :class="{ title: !props.index }">{{ props.item.author }}</td>
					<td :class="{ title: !props.index, subheading: props.index }"><v-icon medium :color="props.item.color">{{ borrowedIcon( props.item.borrowed ) }}</v-icon> {{ borrowedText( props.item.borrowed ) }}</td>
				</tr>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>

export default {
	name: 'HistoryScanTab',
	data ( ) {
		return {
			barcodeSearchRowsPerPage: [
				{
					"text": "$vuetify.dataIterator.rowsPerPageAll",
					"value":-1
				}
			],
			barcode: '',
			barcodeSearchHeaders: [
				{
					text: 'Type',
					value: 'collection',
					sortable: false
				},
				{
					text: 'Title',
					value: 'title',
					sortable: false
				},
				{
					text: 'Author',
					value: 'author',
					sortable: false
				},
				{
					text: 'Borrowed?',
					value: 'borrowed',
					sortable: false
				}
			],
		}
	},
	mounted( ) {
		this.$refs.barcode.focus( );
	},
	computed: {
		barcodeSearch( ) {
			return this.$store.getters[ 'patron/barcodeSearch' ];
		},
		barcodeSearchCount( ) {
			return this.$store.getters[ 'patron/barcodeSearchCount' ];
		},
		barcodeSearchStatus( ) {
			return this.$store.getters[ 'patron/barcodeSearchStatus' ];
		}
	},
	watch: {
		barcodeSearchStatus( updated, orginial ) {
			switch ( updated ) {
				case 'idle':
					this.$refs.barcode.focus( );
					break;
			}
		}
	},
	methods: {
		checkBarcode( ) {
			if ( this.barcode.trim( ) == '' ) {
				return;
			}
			this.$store.dispatch( 'patron/barcodeSearch', this.barcode.trim( ) );
			this.barcode = '';
		},
		borrowedIcon( data ) {
			if ( data == 0 ) {
				return 'alarm_off';
			} else {
				return 'alarm_on';
			}
		},
		borrowedText( data ) {
			if ( data == 0 ) {
				return 'Not borrowed';
			} else {
				return "Borrowed " + data + " times";
			}
		}
	}
}
</script>
